import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@ebw-monorepo/login';
import { ExternalActionService } from '@ebw-monorepo/map';
import { EbwModalService } from '@ebw-monorepo/modal';
import { PERMISSION_NAME, PermissionService, SplitViewService } from '@ebw-monorepo/utils';
import { Observable } from 'rxjs';
import { API_URLS, ApiUrlService } from '../../../../../../utils/src/lib/services/api-url.service';
import { IBookmarkList } from '../../../interfaces/bookmark.interface';
import { MapRequestService } from '../../../services/map-request.service';
import { IHttpMapGet } from './../../../interfaces/httpReq.interface';
import { BookmarkService } from './../../../services/bookmark.service';
import { I18NService } from '@ebw-monorepo/i18n-translate';

@Component({
  selector: 'ebw-monorepo-bookmarks',
  templateUrl: './bookmarks.component.html',
  styleUrls: ['./bookmarks.component.scss']
})
export class BookmarksComponent implements OnInit {
  bookmarks: IBookmarkList[] = [];
  row = 0;
  limit = 10;
  private activeLayers = null;
  pageIndex: number = 0;

  /*flag permesso Visibilità query*/
  flagPermessoVisibilityBookmark: boolean = false;

  inputRicerca = new FormControl();
  public ricerca: string = '';
  filteredBookmarks: Observable<IBookmarkList[]>;
  searchTimeout: any;

  currentUserId: string;

  constructor(
    private ebwModalSrv: EbwModalService,
    private httpSrv: MapRequestService,
    private bookmarkSrv: BookmarkService,
    private router: Router,
    private route: ActivatedRoute,
    private externalSrv: ExternalActionService,
    private _homeSplitView: SplitViewService,
    private _apiUrlService: ApiUrlService,
    private i18nSrv: I18NService,
    private _permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    /*Permesso visibilità bookmark*/
    this.flagPermessoVisibilityBookmark = this._permissionService.checkPermission(
      PERMISSION_NAME.MAP.SIDEBAR.VISIBILITY_BOOKMARK
    );

    this.activeLayers = this.bookmarkSrv.getCurrentLayer();

    this.currentUserId = sessionStorage.getItem(LoginService.USER_ID_KEY);

    this.getBookmarksList();
  }

  getBookmarksList(offset: number = 0) {
    let req: IHttpMapGet = {
      url: this._apiUrlService.createUrl(API_URLS.MAP.BOOKMARK.LIST) + '?offset=' + offset + '&limit=' + this.limit
    };
    if (this.ricerca != '') {
      req.url += '&name=' + this.ricerca;
    }
    this.httpSrv.getMapRequest(req).subscribe({
      next: (resp: any) => {
        this.bookmarks = resp;
        // this.row = resp.numRows;
      },
      error: (error) => {
        this.ebwModalSrv.openErrorModal({
          title: 'common.error',
          content: 'common.data_retrieving_error'
        });
      }
    });
  }

  filterBookmarks(value: string): void {
    const filterValue = value.toLowerCase();
    clearTimeout(this.searchTimeout);

    //Il delay per la ricerca
    this.searchTimeout = setTimeout(() => {
      this.pageIndex = 0;
      this.getBookmarksList();
    }, 500);
  }

  managerViewGo(book?: IBookmarkList) {
    let params = {
      title: 'map.sidebar.bookmark.new_views',
      layers: this.activeLayers,
      id: null,
      oldLayers: null
    };

    if (book) {
      this.positioningOnMap(book.bbox, book.active_layers);
      params = {
        title: book.name,
        layers: book.active_layers,
        id: book.id,
        oldLayers: this.activeLayers
      };
    }

    this.externalSrv.nextViewerManager(true);
    this.router.navigate(['/home', { outlets: { sidebarAction: ['bookmarks-form'] } }], {
      relativeTo: this.route,
      state: params
    });
  }

  atLeastOneFavorite() {
    return this.bookmarks.some((el) => el.isFavourite);
  }

  setOrUnsetAsFavourite(book: IBookmarkList, favourite: boolean) {
    if (favourite && this.atLeastOneFavorite()) {
      this.ebwModalSrv.openErrorModal({
        title: this.i18nSrv.getInstantValue('common.info'),
        content: "Hai già una vista preferita. Rimuovila per impostarne un'altra"
      });
      return;
    }
    const req: IHttpMapGet = {
      url: this._apiUrlService.createUrl(API_URLS.MAP.BOOKMARK.SET_FAVOURITE)
    };

    this.bookmarkSrv.setLayerAsFavourite(req, book.id, book.user_id, !favourite).subscribe({
      next: (resp) => {
        this.getBookmarksList();
      }
    });
  }

  deleteView(id: number, name: string) {
    const confirmModal = this.ebwModalSrv.openConfirmModal({
      title: this.i18nSrv.getInstantValue('common.delete_title'),
      content: this.i18nSrv.getTranslateParameter('common.delete_message', name)
    });

    confirmModal.afterClosed().subscribe((result) => {
      if (result == true) {
        this.bookmarkSrv.deleteBookmark(id).subscribe({
          next: (resp: any) => {
            const success = this.ebwModalSrv.openSuccessModal({
              title: this.i18nSrv.getInstantValue('common.delete_title'),
              content: this.i18nSrv.getInstantValue('common.delete_title')
            });
            this.pageIndex = 0;
            this.getBookmarksList();
          },
          error: (error) => {
            this.ebwModalSrv.openErrorModal({
              title: this.i18nSrv.getInstantValue('common.delete_title'),
              content: this.i18nSrv.getInstantValue('common.delete_error')
            });
          }
        });
      }
    });
  }

  positioningOnMap(bbox: any, activeLayers: string) {
    const currentLayoutConf = this._homeSplitView.viewLayountConfig$.value;
    if (currentLayoutConf && currentLayoutConf.isEnable) {
      currentLayoutConf.halfScreen = true;
      currentLayoutConf.collapsed = false;
      this._homeSplitView.layoutConfChange(currentLayoutConf);
    }

    setTimeout(() => {
      this.bookmarkSrv.positioningOnMap(bbox, activeLayers);
    }, 0);
  }

  changePage(event) {
    let offset = this.limit * event.pageIndex;
    this.pageIndex = event.pageIndex;
    this.getBookmarksList(offset);
  }
}
